import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appMaxLength]',
  standalone: false
})
export class MaxLengthDirective {

  @Input('appMaxLength') maxLength!: number; // Accept maxLength value as input

  constructor(private _el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: InputEvent): void {
    const input = this._el.nativeElement as HTMLInputElement;

    if (input.value.length > this.maxLength) {
      input.value = input.value.substring(0, this.maxLength); // Trim the value to maxLength
      event.stopImmediatePropagation(); // Prevent further propagation
    }
  }

}
